import { styled } from "@mui/material";
import SimpleBar from "simplebar-react";

export const CarScrollBox = styled(SimpleBar)(({ theme }) => ({
  // border: "solid 1px red",
}));
